import { IAccountContactDTO, IAccountContactListItemDTO, IAccountContactsDAO, ICreateAccountContactDTO } from '../account-contacts.dao';
import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IPaginatedContentResponse } from '../shared.dto';
import { ACCOUNT_CONTACTS_LIST_URL, CREATE_ACCOUNT_CONTACT_URL, UPDATE_ACCOUNT_CONTACT_URL } from '../../constants/api/account-contacts-api.constants';

const ACCOUNT_CONTACTS_PAGE_SIZE = 1000;

export class AccountContactsDAO extends IAccountContactsDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAccountContacts(accountId: number): Promise<IAccountContactListItemDTO[]> {
        const callApi = async (page: number = 0, contacts: IAccountContactListItemDTO[] = []): Promise<IAccountContactListItemDTO[]> => {
            const { parsedResponse } = await this.apiClient.get<IPaginatedContentResponse<IAccountContactListItemDTO>>(
                ACCOUNT_CONTACTS_LIST_URL,
                { accountId: accountId, page: page, size: ACCOUNT_CONTACTS_PAGE_SIZE }
            );
            const loadedContacts = contacts.concat(parsedResponse.content ?? []);

            if (page + 1 >= (parsedResponse.totalPages ?? 0)) {
                return loadedContacts;
            }
            return await callApi(page + 1, loadedContacts);
        };

        return await callApi();
    }

    public async createAccountContact(accountId: number, params: ICreateAccountContactDTO): Promise<IAccountContactDTO> {
        const response = await this.apiClient.post<IAccountContactDTO>(CREATE_ACCOUNT_CONTACT_URL, {
            accountId: accountId,
            ...params
        });
        return response.parsedResponse;
    }

    public async updateAccountContact(accountId: number, params: IAccountContactDTO): Promise<IAccountContactDTO> {
        const response = await this.apiClient.put<IAccountContactDTO>(UPDATE_ACCOUNT_CONTACT_URL, {
            accountId: accountId,
            ...params
        });
        return response.parsedResponse;
    }
}
